import { render, staticRenderFns } from "./AddAdminDialog.vue?vue&type=template&id=0ab626c8&scoped=true"
import script from "./AddAdminDialog.vue?vue&type=script&lang=ts"
export * from "./AddAdminDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab626c8",
  null
  
)

export default component.exports